import config from "../config/config";
import identifyEnviromentMobile, {
  postMessageToMobile,
} from "../utils/identifyEnviroment";
import setCookieJwt2, { deleteCookie } from "./setCookie";

const normalizeUrlRedirect = (url) => {
  //url = decodeURI(decodeURI(decodeURI(url)));

  url = url
    .replace("https%3A%2F%2F", "https://")
    .replaceAll("%2F", "/")
    .replaceAll("%252F", "/")
    .replace("com//", "com/")
    .replace("%253A", ":")
    .replace("%253F", "?")
    .replaceAll("%253D", "=")
    .replace("%3F", "?")
    .replaceAll("%3D", "=");

  // .replaceAll("ReturnUrl=Url=","ReturnUrl=")

  if (!url.includes("https")) return `https://${url}`;

  return url;
};

/**
 * @deprecated Problema resuelto con api gateway
 * @param {*} url
 * @returns
 */

const handleOldUrl = (url) => {
  let newUrl = undefined;
  const listUrl = config.LIST_URLs_REDIRECT_REPLACE;
  let path = undefined;

  listUrl.map((element) => {
    if (url.includes(element)) path = element;
  });

  if (path !== undefined) {
    if (path.includes("/sitios/eolgestion"))
      newUrl = `eolqa.errepar.com${path}`;
    if (path.includes("/sitios/suscriptores"))
      newUrl = `erreiusqa.errepar.com${path}`;
  }

  return newUrl !== undefined ? newUrl : url;
};

const validateUrlRedirect = (url) => {
  const urlValids = [
    "errepar.com",
    "errepar.net",
    "erreius.com",
    "estudio.ar",
    "mi.errepar",
    "eol",
    "lsds",
    "awsalphadevqa",
    "localhost",
    "aol",
    "alicuotas",
    "estudio",
    "suscripciones",
    "syserrepar",
    "errepar",
  ];
  let match = false;

  urlValids.map((item) => {
    if (url.includes(item)) match = true;
  });
  return match;
};

const runRedirect = (urlRedirect, jwt, appCode) => {
  let urlRedirectModify = "";
  if (urlRedirect !== null) {
    urlRedirectModify = normalizeUrlRedirect(urlRedirect);
  }

  let url = urlRedirect !== null ? urlRedirectModify : config.REDIRECT_DEFAULT;

  if (urlRedirectModify.includes("http://")) url = urlRedirectModify;

  if (validateUrlRedirect(url)) {
    if (url.includes("syserrepar://")) url = url.replace("https://", ""); // verifico si la redirección es a un scheme

    setCookieJwt2(jwt?.jwt2);

    if (String(appCode).toLowerCase().includes("me") || String(appCode).toLowerCase().includes("cgi") || String(appCode).toLowerCase().includes("cm") ) {
      console.log("Ingresa include ME");
      deleteCookie();
      setCookieJwt2(jwt?.jwt3);
      
      if (identifyEnviromentMobile()) {
        return postMessageToMobile(jwt?.jwt3);
      }
      if (!urlRedirect) {
        const appCodeLowerCase = String(appCode).toLowerCase();
        
        if (appCodeLowerCase.includes("cgi")) {
          url = config.REDIRECT_DEFAULT_CGI;
        } else if (appCodeLowerCase.includes("me")) {
          url = config.REDIRECT_DEFAULT_ME;
        } 
      }
      

     
    }
    return window.location.replace(url);
  }

  return window.location.replace(config.REDIRECT_DEFAULT);
};

/**
 *  @deprecated  use runRedirect
 * @param {*} urlRedirect
 */
const runRedirectWhitOutJwt2 = (urlRedirect) => {
  let urlRedirectModify = "";
  if (urlRedirect !== null) {
    urlRedirectModify = normalizeUrlRedirect(urlRedirect);
    //  urlRedirectModify = handleOldUrl(urlRedirectModify);
  }

  let url = urlRedirect !== null ? urlRedirectModify : config.REDIRECT_DEFAULT;

  if (urlRedirectModify.includes("http://")) url = urlRedirectModify;

  if (url.includes("syserrepar://")) url = url.replace("https://", "");

  return window.location.replace(`${url}`);
};

export {
  validateUrlRedirect,
  normalizeUrlRedirect,
  handleOldUrl,
  runRedirect,
  runRedirectWhitOutJwt2,
};
